export const environment = {
  production: true,
  api: {
    basePath: 'https://teamtransfer-api-dev.azurewebsites.net',
  },
  upload: {
    chunkSizeBytes: 32 * 320 * 1024,
  }
};
